import { rate } from './visitorsFormat'

export type Reason = 'low_score' | 'falling' | 'no_recent_read'

export function reasonLabel(r: Reason): string {
  if (r === 'low_score') return 'Low score'
  if (r === 'falling') return 'Score falling'
  return 'No read in 30 days'
}

export function scoreTone(score: number): 'red' | 'amber' | 'green' {
  return score < 30 ? 'red' : score < 60 ? 'amber' : 'green'
}

/** Quartile levels 1-4 over the non-zero weeks; a week with no engaged time is level 0. */
export function weekGrid(rows: { week_start: string; engaged_ms: number }[]): { week_start: string; level: 0 | 1 | 2 | 3 | 4 }[] {
  const nz = rows.map((r) => r.engaged_ms).filter((v) => v > 0)
  return rows.map((r) => {
    if (r.engaged_ms <= 0) return { week_start: r.week_start, level: 0 }
    const below = nz.filter((v) => v < r.engaged_ms).length
    const level = Math.min(4, Math.floor((below / nz.length) * 4) + 1) as 1 | 2 | 3 | 4
    return { week_start: r.week_start, level }
  })
}

export function cohortCell(v: number | null): { text: string; opacity: number } {
  if (v === null) return { text: '—', opacity: 0 }
  return { text: rate(v), opacity: Math.round((0.1 + 0.9 * v) * 100) / 100 }
}

/** True when the nightly score is more than two days behind `today` (both YYYY-MM-DD). */
export function isStale(scoreDay: string | null, today: string): boolean {
  if (!scoreDay) return false
  return (Date.parse(today) - Date.parse(scoreDay)) / 86_400_000 > 2
}

const DAY_MS = 86_400_000

/** The trend point to compare today's score with: day <= scoreDay - 60, nearest to scoreDay - 90. Null when none. */
export function baselinePoint(trend: { day: string; score: number }[], scoreDay: string | null): { day: string; score: number } | null {
  if (!scoreDay) return null
  const end = Date.parse(scoreDay)
  const ideal = end - 90 * DAY_MS
  let best: { day: string; score: number } | null = null
  for (const p of trend) {
    const t = Date.parse(p.day)
    if (t > end - 60 * DAY_MS) continue
    if (best === null || Math.abs(t - ideal) < Math.abs(Date.parse(best.day) - ideal)) best = p
  }
  return best
}
